import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generatePricesTestData } from '../utils/pricesTestDataGenerator';
import { useParams } from 'react-router-dom';

export const GeneratePricesButton = () => {
  const { id: productId } = useParams();
  
  if (!productId) {
    return null;
  }
  
  return (
    <GenerateTestDataButton
      label="Generate Test Prices"
      generateFunction={(count: number) => generatePricesTestData(count, productId)}
      queryKey={['prices', productId]}
    />
  );
};